import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../../environments/environment'


@Injectable()
export class Web3Service {
	private _web3: any;
	private _account: string = null;
	private _tokenContract: any;
	public _tokenContractAddress: string = "";
	public _decimalSmartContract: number = 0;
	public _transactionBaseURL: string = "";

	public web3Provider: any;
	public chain_id = environment.CHAINID;
	constructor() {
	}
	//#region Web3 and Smart Contract Connection
	public async connect(): Promise<void> {
	/*	await new Promise((resolve, reject) => {
			this.web3Provider = new Web3.providers.HttpProvider(environment.RINKEBY_ETHEREUM_NETWORK);
			console.log("provider", environment.RINKEBY_ETHEREUM_NETWORK)
			this._web3 = new Web3(this.web3Provider);
			resolve("Connected");
		}) as Promise<void>;*/
	}
	public getWeiFromToken(tokens) {
	/*	const tokensInWei = Web3Utils.toWei(tokens.toString())
		return tokensInWei*/
	}
	public connectSmartContract(tokenAbi, smartContractAddress) {
	//	this._tokenContract = new this._web3.eth.Contract(tokenAbi, smartContractAddress);
	}
	//#endregion

	//#region Ledger
	public ledger_eth: any = {};
	public connectLedger(): Promise<void> {
		var self = this;
		return new Promise((resolve, reject) => {
			try {
			/*	ledger.comm_u2f.create_async()
					.then(function (comm) {
						self.ledger_eth = new ledger.eth(comm);
						resolve(self.ledger_eth);
					})
					.catch((ex) => {
						reject(ex);
					});*/
			}
			catch (ex) {
				reject(ex);
			}
		});
	}
	public getLedgerAddresses(derivation_path): Promise<Object> {
		return new Promise((resolve, reject) => {
			/*this.ledger_eth.getAddress_async(derivation_path)
				.then((result: any) => {
					resolve({ address: result.address, derivationPath: derivation_path })
				})
				.catch((error) => {
					reject(error);
				});*/
		});
	}
	public signLedgerAndBroadcastTx(data, rawTx, derivation_path) {
		var self = this;
		return new Promise((resolve, reject) => {

		/*	this.ledger_eth.signTransaction_async(derivation_path, data).then(function (result) {
				rawTx.r = '0x' + result.r;
				rawTx.s = '0x' + result.s;
				rawTx.v = '0x' + result.v;

				var txSigned = new EthereumTx(rawTx);
				var serializedTx = txSigned.serialize();
				resolve(serializedTx);
			}).catch(function (ex) {
				reject(ex);
			});
*/
		})

	}
	public broadcastSerializedTx(serializedTx) {
		let flag = false
		return new Promise((resolve, reject) => {
			/*this._web3
				.eth
				.sendSignedTransaction('0x' + serializedTx.toString('hex'))
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.on('confirmation', function (confirmationNumber, receipt) {
					if (!flag) {
						flag = true
						console.log(receipt)
						resolve(receipt)
					}
				})
				.on('transactionHash', (hash) => {
					console.log(hash)
				})
				.then((hash) => {
					if (hash) {
					}
				}).
				catch((err) => {
					reject(err);
				});*/
		})
	}
	public privateKeyBroadCast(serializedTx) {
		let flag = false
		return new Promise((resolve, reject) => {
			/*this._web3
				.eth
				.sendSignedTransaction('0x' + serializedTx.toString('hex'))
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.on('confirmation', function (confirmationNumber, receipt) {
					if (!flag) {
						flag = true
						console.log(receipt)
						resolve(receipt)
					}
				})
				.on('transactionHash', (hash) => {
					console.log(hash)
				})
				.then((hash) => {
					if (hash) {
					}
				}).
				catch((err) => {
					reject(err);
				});*/
		})
	}
	public signLedgerAndBroadcastTokensTransferTx(data, rawTx, derivation_path) {
		return new Promise((resolve, reject) => {
			/*this.ledger_eth.signTransaction_async(derivation_path, data).then((result) => {
				rawTx.r = '0x' + result.r;
				rawTx.s = '0x' + result.s;
				rawTx.v = '0x' + result.v;

				var txSigned = new EthereumTx(rawTx);
				var serializedTx = txSigned.serialize();
				resolve(serializedTx);

			}).catch(function (ex) {
				reject(ex);
			});*/

		})

	}
	public signLedgerAndBroadcastBulkTokensTransferTx(data, rawTx, derivation_path) {
		return new Promise((resolve, reject) => {
			/*this.ledger_eth.signTransaction_async(derivation_path, data).then((result) => {
				rawTx.r = '0x' + result.r;
				rawTx.s = '0x' + result.s;
				rawTx.v = '0x' + result.v;

				var txSigned = new EthereumTx(rawTx);
				var serializedTx = txSigned.serialize();
				resolve(serializedTx);

			}).catch(function (ex) {
				reject(ex);
			});*/

		})

	}
	public broadCastLedgerTokenTransfer(serializedTx) {
		let flag = false
		return new Promise((resolve, reject) => {
      /*this._web3
        .eth
        .sendSignedTransaction('0x' + serializedTx.toString('hex'))
        .on('receipt', function (receipt) {
          resolve(receipt);
        })
        .on('transactionHash', (hash) => {
          console.log(hash)
          // resolve(hash);
        })
        .on('confirmation', function (confirmationNumber, receipt) {
          if (!flag) {
            flag = true
            console.log(receipt)
            resolve(receipt)
          }
        })
        .then((hash) => {
          if (hash) {
            // resolve(hash);
          }
        }).
        catch((err) => {
          reject(err);
        });*/
		})
	}
	public broadCastLedgerBulkTransfer(serializedTx) {
		let flag = false
		return new Promise((resolve, reject) => {
		/*	this._web3
				.eth
				.sendSignedTransaction('0x' + serializedTx.toString('hex'))
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.on('transactionHash', (hash) => {
					console.log(hash)
				})
				.on('confirmation', function (confirmationNumber, receipt) {
					if (!flag) {
						flag = true
						console.log(receipt)
						resolve(receipt)
					}
				})
				.then((hash) => {
					if (hash) {
						// resolve(hash);
					}
				}).
				catch((err) => {
					reject(err);
				});*/
		})
	}
	public createUnSignedTransactionForLedger(addressToTransfer, numberOfTokens, smartContractAddress, transferAddress) {
		return new Promise((resolve, reject) => {
			/*try {
				numberOfTokens = new BigNumber(numberOfTokens);
				this._web3.eth.defaultAccount = transferAddress;
				var transferFromABI = this._tokenContract
					.methods
					.transfer(addressToTransfer, numberOfTokens)
					.encodeABI();


				this._web3.eth.getTransactionCount(transferAddress, "pending").then((resNonce) => {
					const countHexa = Web3Utils
						.numberToHex(resNonce);
					const valueHexa = Web3Utils
						.numberToHex(0);
					const gasPriceHexa = Web3Utils.numberToHex(20000000000);
					const gasLimitHexa = Web3Utils.numberToHex(1305093);
					var rawTx = {
						from: transferAddress,
						to: smartContractAddress,
						value: valueHexa,
						data: transferFromABI,
						nonce: countHexa,
						gasPrice: gasPriceHexa,
						gasLimit: gasLimitHexa,
						chainId: this.chain_id,
						r: environment.r,
						s: environment.s,
						v: environment.v
					}
					var tx = new EthereumTx(rawTx);
					var serializedTx = tx.serialize();
					resolve({ serializedTx: serializedTx, rawTx: rawTx });
				});
			}
			catch (ex) {
				reject(ex);
			}*/
		});
	}
	public createUnSignedDeployedTransactionForLedger(abi, data, transferAddress) {
		var self = this;
		return new Promise((resolve, reject) => {
			/*try {
				self._web3.eth.defaultAccount = transferAddress;
				self._web3.eth.getTransactionCount(transferAddress, "pending").then((resNonce) => {
					const countHexa = Web3Utils
						.numberToHex(resNonce);
					const valueHexa = Web3Utils
						.numberToHex(0);
					const gasPriceHexa = Web3Utils.numberToHex(20000000000);
					const gasLimitHexa = Web3Utils.numberToHex(1305093);
					// const gasHexa = Web3Utils.numberToHex(gas * 2);
					// gas:
					var rawTx = {
						from: transferAddress,
						value: valueHexa,
						data: '0x' + data,
						nonce: countHexa,
						gasPrice: gasPriceHexa,
						gasLimit: gasLimitHexa,
						chainId: this.chain_id,
						r: environment.r,
						s: environment.s,
						v: environment.v
					}
					var tx = new EthereumTx(rawTx);
					var serializedTx = tx.serialize();
					resolve({ serializedTx: serializedTx, rawTx: rawTx });
				});

			}
			catch (ex) {
				reject(ex);
			}*/
		});
	}
	public createUnSignedTransactionBulkTokenTransferForLedger(addressesArray, tokensArray, smartContractAddress, transferAddress) {
		return new Promise((resolve, reject) => {
			/*try {
				this._web3.eth.defaultAccount = transferAddress;
				// for (var i = 0; i < tokensArray.length; i++) {
				// 	tokensArray[i] = new BigNumber(tokensArray[i]);
				// }
				var transferFromABI = this._tokenContract
					.methods
					.bulkTransfer(addressesArray, tokensArray)
					.encodeABI();
				this._web3.eth.getTransactionCount(transferAddress, "pending")
					.then((resNonce) => {
						const countHexa = Web3Utils
							.numberToHex(resNonce);
						const valueHexa = Web3Utils
							.numberToHex(0);
						const gasPriceHexa = Web3Utils.numberToHex(20000000000);
						const gasLimitHexa = Web3Utils.numberToHex(1305093);
						var rawTx = {
							from: transferAddress,
							to: smartContractAddress,
							value: valueHexa,
							data: transferFromABI,
							nonce: countHexa,
							gasPrice: gasPriceHexa,
							gasLimit: gasLimitHexa,
							chainId: this.chain_id,
							r: environment.r,
							s: environment.s,
							v: environment.v
						}
						var tx = new EthereumTx(rawTx);
						var serializedTx = tx.serialize();
						resolve({ serializedTx: serializedTx, rawTx: rawTx });
					});
			}
			catch (ex) {
				reject(ex);
			}*/
		});
	}
	//#endregion

	//#region MetaMask
	public connectMetaMask() {
		/*if (typeof window.web3 !== 'undefined') {
			// Use Mist/MetaMask's provider
			this._web3 = new Web3(window.web3.currentProvider);

			// if (this._web3.version.network !== '4') {
			//     return { code: 500, message: "Please connect to the Rinkeby network" };
			// }
			return { code: 200, message: "Connected" };
		} else {
			return { code: 500, message: "Please use MetaMask plugin for chrome" };
		}*/
    return { code: 500, message: "Please use MetaMask plugin for chrome" };
	}
	public async deployFromMetaMask(byteCode, abi) {
		/*let account = await this.getAccount();
		return new Promise((resolve, reject) => {
			var Contract = new this._web3.eth.Contract(abi);
			Contract.deploy({ data: byteCode, arguments: [] })
				.send({
					from: account
				}).on('error', function (error) {
					reject(error);
				})
				.on('transactionHash', function (transactionHash) {
				})
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.then(function (newContractInstance) {
				});
		}) as Promise<string>;*/
	}
	//#endregion

	//#region General Smart Contract Functions
	public async transferTokens(addressToTransfer, numberOfTokens): Promise<void> {
		/*let account = await this.getAccount();
		numberOfTokens = new BigNumber(numberOfTokens);
		return new Promise((resolve, reject) => {
			this._tokenContract
				.methods
				.transfer(addressToTransfer, numberOfTokens)
				.send({ from: account })
				.on('transactionHash', function (transactionHash) {
					resolve(transactionHash);
				})
				.then((hash) => {
				})
				.catch((err) => {
					reject(err);
				});
		}) as Promise<void>;*/
	}
	public async getAccount(): Promise<string> {
		/*if (this._account == null) {
			this._account = await new Promise((resolve, reject) => {
				this._web3.eth.getAccounts((err, accs) => {
					if (err != null) {
						reject("There was an error fetching your accounts.");
					}

					if (accs.length === 0) {
						reject('Couldn\'t get any accounts! Make sure your Ethereum client is configured correctly.');
					}
					resolve(accs[0]);
				})
			}) as string;

			this._web3.eth.defaultAccount = this._account;
		}*/

		return Promise.resolve(this._account);
	}
	public isValidAddress(address) {
		//var check = Web3Utils.isAddress(address);
		return true;
	}
	public async getTokenBalanceByAddress(address): Promise<number> {
		return new Promise((resolve, reject) => {
		/*	let _web3 = this._web3;
			this._tokenContract
				.methods.
				balanceOf(address).call()
				.then((balance) => {
					resolve(parseFloat(balance) / Math.pow(10, 18));
				})*/

		}) as Promise<number>;
	}
	public async bulkTokenTransfer(addressesArray, tokensArray) {
		// for (var i = 0; i < tokensArray.length; i++) {
		// 	tokensArray[i] = new BigNumber(tokensArray[i]);
		// }
		let account = await this.getAccount();
		return new Promise((resolve, reject) => {
		/*	let _web3 = this._web3;
			this._tokenContract.methods
				.bulkTransfer(addressesArray, tokensArray)
				.send({ from: account })
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.on('transactionHash', function (transactionHash) {
					console.log(transactionHash)
					// resolve(transactionHash);
				})
				.catch((err) => {
					reject(err);
				});
	*/
    }) as Promise<void>;
	}
	//#endregion

	//#region Web3 Functions
	public getEthBalance(address) {
		return new Promise((resolve, reject) => {
			/*this._web3.eth.getBalance(address)
				.then((balance) => {
					resolve(parseFloat(balance) / Math.pow(10, 18));
				})
				.catch((err) => {
					reject(err);
				})*/
		})
	}
	public async createSignedTransactionForDeployingSmartContract(userPrivateKey: string, data, abi): Promise<string> {
		return new Promise((resolve, reject) => {
			/*try {
				let flag = false
				const provider = new PrivateKeyProvider(userPrivateKey, environment.RINKEBY_ETHEREUM_NETWORK);
				const web3 = new Web3(provider);
				web3.eth.getAccounts()
					.then((accounts) => {
						accounts

						var Contract = new web3.eth.Contract(abi);
						if (userPrivateKey.charAt(0) == '0' && userPrivateKey.charAt(1) == 'x') {
							userPrivateKey = userPrivateKey.slice(2, userPrivateKey.length);
						}
						Contract.deploy({ data: '0x' + data, arguments: [] })
							.send({
								from: accounts[0]
							}).on('error', function (error) {
								reject(error);
							})
							.on('transactionHash', function (transactionHash) {
								console.log(transactionHash)
							})
							.on('receipt', function (receipt) {
								resolve(receipt);
							})
							.on('confirmation', function (confirmationNumber, receipt) {
								if (!flag) {
									flag = true
									console.log(receipt)
									resolve(receipt)
								}
							})
							.then(function (newContractInstance) {
							});
					});
			}
			catch (ex) {
				reject(ex);
			}*/
		}) as Promise<string>;
	}
	public async createSignedTransactionForTokensTransfer(addressToTransfer, numberOfTokens, smartContractAddress, userPrivateKey): Promise<string> {
	/*	numberOfTokens = new BigNumber(numberOfTokens);
		var transferFromABI = this._tokenContract
			.methods
			.transfer(addressToTransfer, numberOfTokens)
			.encodeABI();
		return new Promise((resolve, reject) => {
			try {
				if (userPrivateKey.charAt(0) == '0' && userPrivateKey.charAt(1) == 'x') {
					userPrivateKey = userPrivateKey.slice(2, userPrivateKey.length);
				}
				var wallet = new Wallet('0x' + userPrivateKey);
				this._web3.eth.getTransactionCount(wallet.address, "pending").then((resNonce) => {
					const valueHexa = Web3Utils
						.numberToHex(0);
					const countHexa = Web3Utils
						.numberToHex(resNonce);
					const gasPriceHexa = Web3Utils.
						numberToHex(20000000000);
					const gasLimitHexa = Web3Utils.
						numberToHex(1305093);
					const txParams = {
						to: smartContractAddress,
						nonce: countHexa,
						gasPrice: gasPriceHexa,
						gasLimit: gasLimitHexa,
						value: valueHexa,
						data: transferFromABI,
						chainId: this.chain_id,
					}
					var tx = new EthereumTx(txParams)
					const PRIVATE_KEY = Buffer.from(userPrivateKey, 'hex')
					tx.sign(PRIVATE_KEY);
					tx = tx.serialize();
					resolve(tx);
				});
			}
			catch (ex) {
				reject(ex);
			}
		}) as Promise<string>;*/
    return new Promise<string>((resolve, reject) => {

    })

	}
	public async createSignedTransactionForBulkTokenTransfer(addressesArray, tokensArray, smartContractAddress, userPrivateKey): Promise<string> {
		// for (var i = 0; i < tokensArray.length; i++) {
		// 	tokensArray[i] = new BigNumber(tokensArray[i]);
		// }
	/*	var transferFromABI = this._tokenContract
			.methods
			.bulkTransfer(addressesArray, tokensArray)
			.encodeABI();
		return new Promise((resolve, reject) => {
			try {
				if (userPrivateKey.charAt(0) == '0' && userPrivateKey.charAt(1) == 'x') {
					userPrivateKey = userPrivateKey.slice(2, userPrivateKey.length);
				}
				var wallet = new Wallet('0x' + userPrivateKey);
				this._web3.eth.getTransactionCount(wallet.address, "pending").then((resNonce) => {
					const valueHexa = Web3Utils
						.numberToHex(0);
					const countHexa = Web3Utils
						.numberToHex(resNonce);
					const gasPriceHexa = Web3Utils.
						numberToHex(20000000000);
					const gasLimitHexa = Web3Utils.
						numberToHex(1305093);
					const txParams = {
						to: smartContractAddress,
						nonce: countHexa,
						gasPrice: gasPriceHexa,
						gasLimit: gasLimitHexa,
						value: valueHexa,
						data: transferFromABI,
						chainId: this.chain_id,
					}
					var tx = new EthereumTx(txParams)
					const PRIVATE_KEY = Buffer.from(userPrivateKey, 'hex')
					tx.sign(PRIVATE_KEY);
					tx = tx.serialize();
					resolve(tx);
				});
			}
			catch (ex) {
				reject(ex);
			}
		}) as Promise<string>;

	 */
    return new Promise<string>((resolve, reject) => {

    })
	}
	public async broadCast(serializedTx) {
		/*let flag = false
		return new Promise((resolve, reject) => {
			this._web3
				.eth
				.sendSignedTransaction('0x' + serializedTx.toString('hex'))
				.on('receipt', function (receipt) {
					resolve(receipt);
				})
				.on('transactionHash', (hash) => {
					console.log(hash)
				})
				.on('confirmation', function (confirmationNumber, receipt) {
					if (!flag) {
						flag = true
						console.log(receipt)
						resolve(receipt)
					}
				})
				.then((hash) => {
					if (hash) {

					}
				}).
				catch((err) => {
					reject(err);
				});
		}) as Promise<string>;*/
	}
	validatePrivateKey(privateKey) {
		return new Promise((resolve, reject) => {
      /*	try {
          if (privateKey.charAt(0) == '0' && privateKey.charAt(1) == 'x') {
            privateKey = privateKey.slice(2, privateKey.length);
          }
          var wallet = new Wallet('0x' + privateKey);
          resolve(true);
        }
        catch (ex) {
          reject(ex);
        }*/
      });
	}
	validateDerivationPath(derivationPath: string) {
		var keys = derivationPath.split('/');
		if (keys.length >= 4) {
			if (derivationPath.length > 20) {
				return { code: 400, message: "Invalid Derivation Length" };
			}
			if (!this.isLetter(keys[0])) {
				return { code: 400, message: "Invalid Derivation Path" };
			}
			else {
				return { code: 200, message: "Valid" };
			}
		}
		else {
			return { code: 400, message: "Derivation Path is invalid" };
		}
	}
	isLetter(str) {
		return str.length === 1 && str.match(/[a-z]/i);
	}
	//#endregion

}
